/**
 * Documentação pública da API aberta pelo link "Desenvolvedor" do menu do CLIENTE (F-55).
 *
 * URL FIXA, a mesma em TODOS os ambientes (produção, staging, development) — decisão do
 * operador em 2026-11-03. É proposital: não derive de `window.configs.SERVER_URL_PROD`.
 * O link "Documentação" do ADMIN é outro: Swagger completo do servidor do ambiente
 * (`${SERVER_URL_PROD}/doc`), que lista também as rotas de admin.
 */
export const URL_DOCUMENTACAO_API_CLIENTE = 'https://dev.2.whiz.net.br/docs/api';
